import { Button } from "./Button";

export default function FormActions({
  onCancel,
  submitDisabled,
  submitLabel,
  loadingLabel,
  loading,
}) {
  return (
    <>
      <div className="hidden md:flex justify-end gap-3 pt-2">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="submit"
          disabled={submitDisabled}
          loading={loading}
          loadingLabel={loadingLabel}
          style={{ background: "#2d7a7a" }}
        >
          {submitLabel}
        </Button>
      </div>

      <div className="md:hidden fixed bottom-0 left-0 right-0 flex gap-3 p-4 bg-[#fff]">
        <Button type="button" variant="secondary" onClick={onCancel} className="flex-1">
          Cancel
        </Button>
        <Button
          type="submit"
          disabled={submitDisabled}
          loading={loading}
          loadingLabel={loadingLabel}
          className="flex-1"
          style={{ background: "#2d7a7a" }}
        >
          {submitLabel}
        </Button>
      </div>
    </>
  );
}
